module.exports = __webpack_public_path__ + "img/ticket-simple.3469399e.svg";